interface StructureLockInput {
	/** The lock the parent already resolved — identical to the displayed lock icon. */
	isLocked?: boolean;
	/** The campaign's entry in `listData.campaignStatuses`, derived by the API. */
	campaignStatusInfo?: { locked?: boolean };
	/** The campaign's row from the legacy assigned-to-campaigns endpoint. */
	assignedCampaign?: { hasActiveProspects?: boolean; hasProcessedStep?: boolean };
}

/**
 * Whether the campaign builder must hide its structural controls (delete, add step, conditions,
 * senders). Text edits stay available either way.
 *
 * The parent's value wins so the editor's gating can never disagree with the lock icon the user
 * sees; the derived campaign status is next, and the legacy endpoint is the last resort. All three
 * mean the same thing since PREC-3853: a step of the sequence has actually been sent. Assigning
 * leads no longer locks anything, and `hasActiveProspects` is deliberately not consulted — it also
 * counts schedules that only ever failed, which contacted nobody.
 */
export function resolveStructureLock({
	isLocked,
	campaignStatusInfo,
	assignedCampaign,
}: StructureLockInput): boolean {
	if (isLocked !== undefined) {
		return isLocked;
	}

	if (campaignStatusInfo?.locked !== undefined) {
		return campaignStatusInfo.locked;
	}

	return assignedCampaign?.hasProcessedStep ?? false;
}
